import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import "react-datepicker/dist/react-datepicker.css";
import { MdRemoveRedEye, MdEdit } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { BeatLoader, BounceLoader } from "react-spinners";
import { useReactToPrint } from "react-to-print";
import pdf from "../../../../assets/images/img-icons/pdf.png";
import excel from "../../../../assets/images/img-icons/excel.png";
import * as yup from "yup";

import {
  resetCustomerSinglePolicyDetailsView,
  searchAppliedPolicies,
} from "../../../../redux/slice/policy/policySlice";
import PageTitle from "../../../../components/partials/PageTitle";
import {
  exportXlsxData,
  sortUsersByOffice,
} from "../../../../utils/helpers/functions";
import PaginationLinks from "../../../../components/pagination/PaginationLinks";
import CustomerType from "../../../../components/modals/customers/create/CustomerType";
import {
  filteredSavingsPolicies,
  getAppliedSavingsPolicies,
  getSingleSavingsPolicyCover,
  resetCustomerSingleSavingsPolicyDetailsView,
  resetPolicyStatus,
  resetSinglePolicy,
} from "../../../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import Select from "./../../../../components/form/select/Select";
import { resetAttachPolicyCustomer } from "../../../../redux/slice/customer/customerSlice";

// sort customers base on whether corperate or individual customers
// const sortCorperateCustomers = (customers) =>
//   customers?.corperate?.data?.filter(
//     (customer) => customer?.customer_type === "Corporate"
//   );

// main component starts here
const AppliedSavingsPolicies = () => {
  // redux state calls
  const { user } = useSelector((state) => state?.auth?.user);
  const { unpaginated_users } = useSelector((state) => state?.user);
  const {
    offices: { offices },
  } = useSelector((state) => state.office);
  const {
    applied_savings_policies,
    isSuccess,
    isFiltered,
    isFiltering,
    isSearching,
  } = useSelector((state) => state?.savingsPolicy);
  const [currentAppliedPolicies, setCurrentAppliedPolicies] = useState(
    applied_savings_policies?.data?.data
  );
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  // local states and refs
  const [viewCustomer, setViewCustomer] = useState();
  // const [editPolicy, setEditPolicy] = useState();
  // const [attachPolicy, setAttachPolicy] = useState()
  const [sortedUsers, setSortedUsers] = useState([]);
  const [filtered, setFiltered] = useState("");
  const [filteredItem, setFilteredItem] = useState(false);
  const [searchBy, setSearchBy] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const agentCusRef = useRef();
  const allCorperateCustomers = useRef();
  const appliedPoliciesRef = useRef();
  const searchCorp = useRef();
  const CCPdfRef = useRef();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "Applied Savings Policy",
  });
  // breadcrumb
  const breadcrumb = {
    from: {
      title: "Applied Savings Policy",
      link: "/admin/all-applied-savings-policies",
    },
    current: {
      title: "overview",
      link: null,
    },
  };

  const handleSearchBy = (e) => {
    e.preventDefault();
    if (searchBy) {
      dispatch(
        // searchAppliedPolicies({ search: searchBy, office_id: user?.office_id })
        getAppliedSavingsPolicies({
          pageNumber,
          office_id: user?.office_id,
          search: searchBy,
        })
      );
    }
  };

  // fetch customers on click of pagination links
  const fetchCorperateCustomersHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(
      getAppliedSavingsPolicies({
        pageNumber: pageNum,
        office_id: user?.office_id,
        search: searchBy,
      })
    );
    dispatch(resetPolicyStatus());
  };

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleSubmit,
    setFieldValue,
    setFieldError,
    resetForm,
  } = useFormik({
    initialValues: {
      office_id: "",
      staff_id: "",
    },
    validationSchema: () =>
      yup.object().shape({
        office_id: yup.number().required("Office is required"),
      }),
    onSubmit: (values) => {
      if (values?.staff_id === undefined) {
        values["staff_id"] = "";
      }
      dispatch(resetPolicyStatus());
      dispatch(filteredSavingsPolicies(values));
      setSearchBy("");
    },
  });

  const clearFilteredItems = () => {
    appliedPoliciesRef?.current?.clearValue();
    // agentCusRef?.current?.clearValue();
    setSearchBy("");
    dispatch(
      getAppliedSavingsPolicies({
        pageNumber: pageNumber,
        office_id: user?.office_id,
        search: "",
      })
    );
    resetForm();
    setFilteredItem(false);
  };

    useEffect(() => {
      setViewCustomer(
        user_permissions?.some(
          (permission) => permission.name === "view customer details"
        )
      );
      // setEditPolicy(
      //   user_permissions?.some(
      //     (permission) => permission.name === "edit applied policy"
      //   )
      // );
    }, [user_permissions]);

  // get applied savings policies on first load
  useEffect(() => {
    if (!searchBy) {
      dispatch(
        getAppliedSavingsPolicies({
          pageNumber: 1,
          office_id: user?.office_id,
          search: "",
        })
      );
    }
    dispatch(resetPolicyStatus());
  }, [dispatch, user?.office_id, searchBy]);

  useEffect(() => {
    if (applied_savings_policies) {
      setCurrentAppliedPolicies(applied_savings_policies?.data);
      dispatch(resetCustomerSinglePolicyDetailsView());
    }
  }, [applied_savings_policies]);

  useEffect(() => {
    agentCusRef?.current?.clearValue();
    if (values?.office_id) {
      let sortedUsers = sortUsersByOffice(values?.office_id, unpaginated_users);
      setSortedUsers(sortedUsers);
    } else {
      setSortedUsers([]);
    }
  }, [values?.office_id, unpaginated_users]);

  // filtering by search input
  useEffect(() => {
    if (isSuccess) {
      setFiltered("");
      dispatch(resetPolicyStatus());
    }
    if (isFiltered) {
      setFilteredItem(true);
    }

    if (searchBy) {
      setFilteredItem(true);
    }

    if (filtered !== "") {
      setCurrentAppliedPolicies(
        applied_savings_policies?.data?.filter(
          (item) => item.status === filtered
        )
      );
    } else {
      setCurrentAppliedPolicies(applied_savings_policies?.data);
    }
  }, [filtered, isSuccess]);

    useEffect(() => {
      if (
        !user_permissions?.some(
          (permission) => permission.name === "policy module"
        )
      ) {
        navigate("/admin/dashboard");
      }
    }, [navigate, user_permissions]);

  useEffect(() => {
    dispatch(resetAttachPolicyCustomer());
    dispatch(resetSinglePolicy());
    dispatch(resetCustomerSingleSavingsPolicyDetailsView());
    // dispatch(resetAttachedPolicyPreview());
  }, [dispatch]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Applied Savings Policies' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* Table row */}

      {!applied_savings_policies && (
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      )}

      {applied_savings_policies ? (
        <>
          <div className='card p-1 px-3'>
            <div className='row mb-3'>
              <form className='col-md-10' onSubmit={handleSubmit}>
                <div className='row mt-4'>
                  <div className='col-sm-2 text-end sm-text-end'>
                    <label htmlFor='account_type' className={`form-label mt-1`}>
                      Office <span className='text-danger'>*</span>
                    </label>
                  </div>

                  <div className='col-sm-6'>
                    <Select
                      onBlur={() => {
                        handleBlur({ target: { name: "office_id" } });
                      }}
                      name='office_id'
                      data={offices?.map((item, i) => ({
                        label: item?.office_name,
                        value: item?.id,
                      }))}
                      isLoading={offices?.length < 1 && true}
                      // value={parseInt(values?.office_id)}
                      onChange={(selectedOption) => {
                        setFieldValue("office_id", selectedOption?.value);
                      }}
                      ref={appliedPoliciesRef}
                    />
                    {errors?.office_id && touched?.office_id && (
                      <p className='mb-0 text-danger'>
                        {errors?.office_id + "*"}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row mt-2'>
                  <div className='col-sm-2 text-end sm-text-end'>
                    <label htmlFor='account_type' className={`form-label mt-1`}>
                      Agent
                    </label>
                  </div>
                  <div className='col-sm-6'>
                    <Select
                      onBlur={() => {
                        handleBlur({ target: { name: "staff_id" } });
                      }}
                      name='staff_id'
                      ref={agentCusRef}
                      data={
                        values.office_id === 1
                          ? unpaginated_users?.map((item) => ({
                              label: item?.last_name + " " + item?.first_name,
                              value: item?.staff_id,
                            }))
                          : sortedUsers
                      }
                      onChange={(selectedOption) => {
                        setFieldValue("staff_id", selectedOption?.value);
                        setFieldError("staff_id", "");
                      }}
                    />
                    <div className='d-flex align-items-center gap-2 mt-2'>
                      <button type='submit' className='btn btn-sm btn-primary '>
                        Filter
                      </button>
                      {filteredItem ? (
                        <button
                          type='button'
                          className='btn btn-sm btn-secondary'
                          onClick={clearFilteredItems}
                        >
                          Clear Filter
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </form>
              <div className='col-md-2 pt-3'>
                <div className='d-flex justify-content-end'>
                  <Link
                    to={"/admin/attach-customer"}
                    className='btn btn-sm btn-primary mt-2 m-0'
                  >
                    Attach Policy
                  </Link>
                </div>
              </div>
            </div>

            <div className='d-flex justify-content-between align-items-center py-2 mt-2'>
              {/* <h4 className='text-primary-1'>All Customers</h4> */}
              <div>
                <h4 className='text-primary-1'>Applied Policies</h4>
              </div>
              <div className='d-flex justify-content-between align-items-center gap-3'>
                <form
                  onSubmit={handleSearchBy}
                  className='d-flex bg-primary-1 align-items-center '
                  style={{ height: "30px", width: "217px" }}
                  ref={searchCorp}
                >
                  <input
                    type='search'
                    value={searchBy}
                    className='border-0'
                    placeholder='Search...'
                    onChange={(e) => setSearchBy(e.target.value)}
                    style={{
                      height: "28px",
                      marginLeft: "1px",
                      outline: "none",
                    }}
                  />
                  <button
                    type='submit'
                    className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                    style={{ height: "28px" }}
                  >
                    <i className='uil uil-search text-white fs-4'></i>
                  </button>
                </form>
                <div className=' d-flex align-items-center border '>
                  <span
                    className='bg-info me-2 text-white'
                    style={{ padding: "3px" }}
                  >
                    Export to
                  </span>

                  <span
                    href='#'
                    id='btnExport'
                    className='me-1 cursor-p'
                    title='Export to Pdf'
                    onClick={generatePDF}
                  >
                    <img
                      src={pdf}
                      alt='export-pdf'
                      style={{ height: "20px" }}
                    />
                  </span>
                  {currentAppliedPolicies ? (
                    <CSVLink
                      data={exportXlsxData(
                        currentAppliedPolicies,
                        "All Savings Policies"
                      )}
                      style={{ fontWeight: "bolder", cursor: "pointer" }}
                      filename='Corperate customers'
                    >
                      <span
                        href='#'
                        id='btnExport'
                        className='mr-1'
                        title='Export to Excel'
                      >
                        <img
                          src={excel}
                          alt='export-excel'
                          style={{ height: "20px", marginRight: "5px" }}
                        />
                      </span>
                    </CSVLink>
                  ) : null}
                </div>
              </div>
            </div>
            <div className='col-12'>
              <div className='position-relative'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='table-responsive'>
                      <table
                        className='table table-centered table-striped nowrap w-100 no-footer'
                        ref={CCPdfRef}
                      >
                        <thead>
                          <tr>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "130.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Policy No.
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "225.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Policy Name
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "167.8px" }}
                            >
                              Office
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "167.8px" }}
                              aria-label='Email: activate to sort column ascending'
                            >
                              Agent
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "206.8px" }}
                              aria-label='Location: activate to sort column ascending'
                            >
                              Customer Name
                            </th>
                            <th
                              className='sorting sorting_asc'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "166.8px" }}
                            >
                              Sum Assured (&#8358;)
                            </th>
                            <th
                              className='sorting sorting_asc'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                            >
                              Status
                            </th>
                            {viewCustomer && (
                            <th
                              className='sorting text-center'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "165.8px" }}
                              aria-label='Status: activate to sort column ascending'
                            >
                              Action
                            </th>
                            )}
                          </tr>
                        </thead>
                        {currentAppliedPolicies?.length ? (
                          <tbody>
                            {currentAppliedPolicies?.map((item, i) => (
                              <tr key={i}>
                                <td>
                                  <span>{item.policyApplicationNumber}</span>
                                </td>
                                <td>{item?.policyName}</td>
                                <td className=''>{item?.officeName}</td>
                                <td className=''>
                                  {item?.agentFirstName +
                                    " " +
                                    item?.agentLastName}
                                </td>
                                <td>
                                  {item?.customerFirstName +
                                    " " +
                                    item?.customerLastName}
                                </td>
                                <td>{item?.sum_assured}</td>
                                <td>
                                  <span className='badge badge-success-lighten'>
                                    {item?.application_status === "2" &&
                                      "Active"}
                                  </span>
                                  <span className='badge badge-warning-lighten'>
                                    {item?.application_status === "1" &&
                                      "Pending"}
                                  </span>
                                  <span className='badge badge-info-lighten'>
                                    {item?.application_status === "3" &&
                                      "Matured"}
                                  </span>
                                  <span className='badge badge-danger-lighten'>
                                    {item?.application_status === "4" &&
                                      "Terminated"}
                                  </span>
                                  <span className='badge badge-danger-lighten'>
                                    {item?.application_status === "5" &&
                                      "Death"}
                                  </span>
                                </td>
                                {viewCustomer && (
                                <td className='text-center'>
                                  <Link
                                    to={`/admin/customer-savings-policy-view`}
                                    className='text-left'
                                    state={{
                                      customerId: item?.customer_id,
                                      policyAppNumber:
                                        item?.policyApplicationNumber,
                                    }}
                                    // onClick={() =>
                                    //   dispatch(
                                    //     getSingleSavingsPolicyCover(
                                    //       item?.policy_id
                                    //     )
                                    //   )
                                    // }
                                  >
                                    <MdRemoveRedEye
                                      className='text-primary'
                                      style={{
                                        fontSize: "20px",
                                        textAlign: "start",
                                      }}
                                    />
                                  </Link>
                                  {/* {editPolicy && (
                                  <Link
                                    to='/admin/policy-application/edit'
                                    className='ms-2'
                                    state={{
                                      policy_number:
                                        item.policyApplicationNumber,
                                      customer_id: item.customer_id,
                                    }}
                                  >
                                    <MdEdit size={20} />
                                  </Link>
                                  )} */}
                                </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        ) : null}
                      </table>
                    </div>
                    {currentAppliedPolicies?.length < 1 ? (
                      <h5 className='alert alert-info'>No result found!</h5>
                    ) : null}
                    <div className='row mt-2'>
                      <div className='col-sm-12 col-md-6'>
                        <div
                          className='dataTables_info table-pages'
                          id='products-datatable_info'
                          role='status'
                          aria-live='polite'
                        >
                          Showing savings polocies{" "}
                          {applied_savings_policies?.from
                            ? applied_savings_policies?.from
                            : 0}{" "}
                          to{" "}
                          {applied_savings_policies?.to
                            ? applied_savings_policies?.to
                            : 0}{" "}
                          of {applied_savings_policies?.total}
                        </div>
                      </div>
                      <div className='col-sm-12 col-md-6'>
                        <PaginationLinks
                          paginationData={
                            applied_savings_policies
                          }
                          getNextPage={fetchCorperateCustomersHandler}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {isFiltering && searchBy !== undefined && (
                  <div
                    className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                    style={{ height: "100%" }}
                  >
                    <div className='mx-auto'>
                      <BounceLoader
                        color='#090b8f'
                        loading={true}
                        // cssOverride={override}
                        size={50}
                        aria-label='Loading Spinner'
                        data-testid='loader'
                        className='ms-3'
                      />
                      <span className='fw-bolder text-primary-1 ms-2'>
                        Please wait...
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <CustomerType modal_id='create_customer_step_1' />
          </div>
        </>
      ) : null}
    </>
  );
};

export default AppliedSavingsPolicies;
